import { FC, useMemo, useCallback } from 'react'
import { ComposeId } from 'interfaces/feed'
import { createComposeLinkSelector } from 'selectors/feedComposeSelectors'
import { useStoreDispatch, useShallowSelector } from 'helpers/reactReduxHelpers'
import { MediaLink } from 'interfaces/media'
import { Removable } from 'components/features/pfm/Removable/Removable'
import { FetchedLink } from 'components/features/socialFeed/FeedPost/FetchedLink'
import { feedComposeFetchLinkRemoveActionCreator } from 'actions/feedComposeActions'

type ComposeFetchedLink = {
  composeId: ComposeId
}

export const ComposeFetchedLink: FC<ComposeFetchedLink> = (props) => {
  const {
    composeId,
  } = props

  const composeLinkSelector = useMemo(createComposeLinkSelector, [])
  const link = useShallowSelector<MediaLink | null>((state) => composeLinkSelector(state, props))
  const dispatch = useStoreDispatch()

  const handleRemove = useCallback(() => {
    dispatch(feedComposeFetchLinkRemoveActionCreator({ composeId }))
  }, [dispatch, composeId])

  if (!link || link.type === 'image') {
    return null
  }

  return (
    <Removable onRemove={ handleRemove }>
      <FetchedLink { ...link } />
    </Removable>
  )
}
